<template>
    <div class="container">
        <div class="title">
            <div class="title-text">
                <img src="../imgs/navigation_icon_goods.png" class="title-logo">
                <span>优惠活动列表管理</span>
            </div>
            <el-button v-if="showDataList" @click="addEdit" type="primary" size="small" class="add-button">添加</el-button>
            <el-button v-if="!showDataList" @click="backList" type="primary" size="small" class="add-button">返回</el-button>
        </div>
        <div v-if="showDataList">
            <el-row type="flex" :gutter="20">
                <el-col :span="2">
                    <span>优惠券名称</span>
                </el-col>
                <el-col :span="4">
                    <el-input v-model="searchObj.promotionName" placeholder="请输入"></el-input>
                </el-col>
                <el-col :span="2">
                    <span>优惠券活动ID</span>
                </el-col>
                <el-col :span="4">
                    <el-input v-model="searchObj.promotionId" placeholder="请输入,多个ID用,分隔"></el-input>
                </el-col>
                <el-col :span="2">
                    <span>优惠券ID</span>
                </el-col>
                <el-col :span="4">
                    <el-input v-model="searchObj.couponId" placeholder="请输入,多个ID用,分隔"></el-input>
                </el-col>
                <el-col :span="2">
                    <span>优惠券范围</span>
                </el-col>
                <el-col :span="4">
                    <el-select v-model="searchObj.couponUseRangType" placeholder="请选择范围">
                        <el-option
                            v-for="item in promotionTypeArr"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-col>
            </el-row>
            <el-row type="flex" justify="start">
                <el-col :span="2">
                    <span>领取时间</span>
                </el-col>
                <el-col :span="10">
                    <el-date-picker
                        v-model="searchObj.drawTime"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>
                </el-col>
                <el-col :span="2">
                    <span>优惠券状态</span>
                </el-col>
                <el-col :span="4">
                    <el-select v-model="searchObj.isReceivable" placeholder="请选择状态">
                        <el-option
                            v-for="item in promotionStatusArr"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="2" v-if="$developerType===2">
                    <span>店铺ID</span>
                </el-col>
                <el-col :span="4" v-if="$developerType===2">
                    <el-input v-model="searchObj.merchantCode" placeholder="请输入"></el-input>
                </el-col>
                <el-col :span="2">
                    <el-button type="primary" @click="searchData" class="search-btn">查询</el-button>
                </el-col>
                <el-col :span="2">
                    <el-button @click="resetData">重置</el-button>
                </el-col>
            </el-row>
            <el-table
                :data="tableData"
                border
                style="width: 100%; margin-top: 20px">
                <el-table-column
                    prop="parent_id"
                    label="序号"
                    width="50">
                    <template slot-scope="scope">
                        <div>{{scope.$index + 1}}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="promotionId"
                    label="优惠活动ID"
                    width="100">
                </el-table-column>
                <el-table-column
                    prop="couponId"
                    label="优惠券ID"
                    width="100">
                </el-table-column>     
                <el-table-column
                    prop="couponUseRangTypeDisplay"
                    label="优惠券范围"
                    width="80">
                </el-table-column>
                <el-table-column
                    prop="discountCodeName"
                    label="优惠券类型"
                    width="80">
                </el-table-column>
                <el-table-column
                    v-if="$developerType===2"
                    prop="merchantName"
                    label="店铺名称"
                    width="80">
                </el-table-column>
                <el-table-column
                    v-if="$developerType===2"
                    prop="merchantCode"
                    label="店铺ID"
                    width="80">
                </el-table-column>
                <el-table-column
                    prop="promotionName"
                    label="优惠券名称"
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="isReceivableDisplay"
                    label="发券状态"
                    width="80">
                </el-table-column>
                <el-table-column
                    prop="maxNum"
                    label="库存数"
                    width="80">
                </el-table-column>
                <el-table-column
                    prop="maxNumPer"
                    label="每人限领"
                    width="80">
                </el-table-column>
                <el-table-column
                    prop="maxReduceNum"
                    label="已领数"
                    width="80">
                </el-table-column>
                <el-table-column
                    label="领取时间"
                    width="80">
                    <template slot-scope="scope">
                        <span>{{scope.row.promotionStartTimeDisplay}}</span>-<span>{{scope.row.useEndTimeDisplay}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="使用时间"
                    width="80">
                    <template slot-scope="scope">
                        <span>{{scope.row.useStartTimeDisplay}}</span>-<span>{{scope.row.promotionEndTimeDisplay}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="discountParamDisplay"
                    label="活动规则"
                    width="150">
                </el-table-column>
                <el-table-column
                    label="操作"
                    width="190">
                    <template slot-scope="scope">
                        <!-- <el-tooltip class="item" effect="dark" content="编辑优惠活动" placement="top">
                            <el-button 
                                plain
                                type="primary" 
                                icon="el-icon-edit"
                                size="mini"
                                @click="clickEdit(scope.row)"></el-button>
                        </el-tooltip> -->
                        <el-tooltip class="item" effect="dark" content="编辑优惠活动" placement="top">
                            <el-button 
                                plain
                                type="primary" 
                                icon="el-icon-edit"
                                size="mini"
                                @click="selectDialog()"></el-button>
                        </el-tooltip>
                        <!-- <el-button
                            size="mini"
                            @click="modifyreceivable(scope.row)">
                                <div v-if="scope.row.isReceivable === 0">启用</div>
                                <div v-if="scope.row.isReceivable === 1">暂停</div>
                        </el-button> -->
                        <el-button
                            size="mini"
                            @click="selectDialog()"
                            v-if="scope.row.isReceivable === 0">
                                <div>启用</div>
                        </el-button>
                        <el-button
                            size="mini"
                            @click="modifyreceivable(scope.row)"
                            v-if="scope.row.isReceivable === 1">
                                <div>暂停</div>
                        </el-button>
                        <div style="margin-top: 5px;">
                            <!-- <el-button
                                type="primary"
                                size="mini"
                                v-if="$developerType === 3"
                                @click="copyOneList(scope.row)">
                                复制
                            </el-button> -->
                            <el-button
                                type="primary"
                                size="mini"
                                v-if="$developerType === 3"
                                @click="selectDialog()">
                                复制
                            </el-button>
                            <el-button
                                type="primary"
                                size="mini"
                                v-if="$developerType === 2"
                                @click="operateDialog()">
                                复制
                            </el-button>
                            <el-button
                                type="primary"
                                size="mini"
                                @click="viewData(scope.row)">
                                查看数据
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>

            <div class="pagation-wrapper">
                <span class="pagation-text">共{{ pageInfo.totalPage }}页</span>
                <el-pagination
                    @size-change="handlePageSizeChange"
                    @current-change="handleCurrentPageChange"
                    layout="prev, pager, next"
                    :page-sizes="[10, 20, 50, 100]"
                    :total="pageInfo.totalCount">
                </el-pagination>
            </div>
        </div>
        <div v-else>
            <div class="detail-line-wrapper">
                <div v-for="item in showDetailPromotionArr" :key="item.detailTitle" class="detail-line-data">
                    <span>{{item.detailTitle}}：</span>
                    <span>{{item.detailContent}}</span>
                </div>
            </div>
        </div>
        <el-dialog
        title="提示"
        :visible.sync="businessDialogVisible"
        width="30%">
            <span style>商家后台系统升级，期间优惠券的编辑和启用功能暂不可用，预计 7 月 1日之后恢复使用。优惠券的添加、停用的功能不受影响，还请您谅解！</span>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="businessDialogVisible = false">知道了</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="提示"
            :visible.sync="operateDialogVisible"
            width="30%">
                <span>商家后台系统升级，期间优惠券的添加、编辑、启用、复制功能暂不可用，预计 7 月 1日之后恢复使用。优惠券的停用功能不受影响，还请您谅解！</span>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="operateDialogVisible = false">知道了</el-button>
                </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data() {
        return {
            businessDialogVisible: false,
            operateDialogVisible: false,
            showDataList: true,
            tableData: [],
            pageInfo: {
                currentPage: 1,
                pageSize: 10,
                totalPage: 1,
                totalCount: 0
            },
            formLabelWidth: false,
            stockInfo: {
                promotionId: 0,
                maxNum: 0,
                promotionName: '',
                oldMaxNum: 0,
                dialogFormVisible: false
            },
            searchObj: {
                // 优惠券名称
                promotionName: '',
                // 优惠券活动id
                promotionId: '',
                // 优惠券id
                couponId: '',
                // 优惠券范围
                couponUseRangType: '',
                // 优惠券状态值
                isReceivable: '',
                // 领取时间
                drawTime: [],
                // 店铺/平台ID
                merchantCode: ''
            },
            // 筛选优惠券产生数据的时间选择器
            couponDataTime: [],
            // 优惠券类型选项
            promotionTypeArr: [
                {
                    value: 0,
                    label: '全平台券'
                },
                {
                    value: 1,
                    label: '全店铺券'
                }
            ],
            // 优惠券状态选项
            promotionStatusArr: [
                {
                    value: 0,
                    label: '未启用'
                },
                {
                    value: 1,
                    label: '启用'
                }
            ],
            showDetailPromotionArr: [
                {
                    detailTitle: '优惠券发行总数',
                    detailType: 'maxNum',
                    detailContent: 0
                },
                {
                    detailTitle: '领取张数',
                    detailType: 'maxReduceNum',
                    detailContent: 0
                },
                {
                    detailTitle: '使用量',
                    detailType: 'useNum',
                    detailContent: 0
                },
                {
                    detailTitle: '券使用率',
                    detailType: 'useRate',
                    detailContent: 0
                },
                {
                    detailTitle: '券消耗金额（元）',
                    detailType: 'useAmount',
                    detailContent: 0
                }
            ]
        };
    },
    mounted() {
        this.loadData();
    },
    // watch: {
    //     searchObj: {
    //         handler(newObj, oldObj) {
    //             console.log(newObj, oldObj, 999)
    //         },
    //         deep: true,
    //         immediate: true
    //     }
    // },
    methods: {
        // 查询
        searchData() {
            // this.searchObjParams = JSON.parse(JSON.stringify(this.searchObj));
            // this.searchObjParams.promotionStartTime = Date.parse(this.searchObj.drawTime[0]) || '';
            // this.searchObjParams.promotionEndTime = Date.parse(this.searchObj.drawTime[1]) || '';
            // delete this.searchObjParams.drawTime;
            this.loadData();
        },
        // 重置
        resetData() {
            for (let key in this.searchObj) {
                this.searchObj[key] = '';
            }
            this.loadData();
        },
        loadData() {
            let params = {...this.searchObj};
            params.promotionStartTime = Date.parse(this.searchObj.drawTime[0]) || '';
            params.promotionEndTime = Date.parse(this.searchObj.drawTime[1]) || '';
            delete params.drawTime;

            params.currentPage = this.pageInfo.currentPage;
            params.pageSize = this.pageInfo.pageSize;
            // 模拟数据
            // this.tableData = this.pageData;
            this.$api.promotionList(params).then(res => {
                if (+res.code !== 0) {
                    this.$notify.error({
                        title: '错误',
                        message: res.errmsg
                    });
                    return;
                }
                this.tableData = res.data.pageData;
                this.pageInfo = res.data;
            })
            .catch(e => {
                // 接口失败做的操作
                console.log(e);
            });
        },
        handlePageSizeChange(pageSize) {
            this.pageInfo.pageSize = pageSize;
            this.loadData();
        },
        handleCurrentPageChange(currentPage) {
            this.pageInfo.currentPage = currentPage;
            this.loadData();
        },
        parseRes(res) {
            // 接口成功做的操作
            if (+res.code === 0) {
                this.$message({
                    message: '操作成功.',
                    type: 'success'
                });
                this.initData();
            } else {
                this.$alert(res.msg, {
                    confirmButtonText: '确定',
                    dangerouslyUseHTMLString: true
                });
            }
        },
        businessDialog() {
            this.businessDialogVisible = true;
        },
        operateDialog() {
            this.operateDialogVisible = true;
        },
        selectDialog() {
            if(this.$developerType === 2) {
                this.operateDialogVisible = true;
            }else if(this.$developerType === 3) {
                this.businessDialogVisible = true;
            }
        },
        parseError(e) {
            console.log(e);
            // 接口失败做的操作
            this.$alert('服务器异常请稍后重试！', {
                confirmButtonText: '确定'
            });
        },
        initData() {
            this.loadData();
            this.initStockInfo();
        },
        initStockInfo() {
            this.stockInfo = {
                promotionId: 0,
                maxNum: 0,
                promotionName: '',
                oldMaxNum: 0,
                dialogFormVisible: false
            };
        },
        modifyreceivable(row) {
            let params  = {};
            if (+row.isReceivable === 0) {
                params.isReceivable = 1;
            } else {
                params.isReceivable = 0;
            }
            params.promotionCode = row.promotionCode;

            let startTitle = '启动活动';
            let endTitle = '暂停活动';
            let startWord = '优惠券启用后，将正常发放卡券，确定启动活动？';
            let endWord = '活动暂停后，优惠券无法正常发放，确认暂停活动？';
            this.$confirm(row.isReceivable === 0 ? startWord : endWord, row.isReceivable === 0 ? startTitle : endTitle, {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$api.modifyreceivable(params).then(res => {
                    if (+res.code === 0) {
                        this.$message({
                            type: 'success',
                            message: '操作成功'
                        });
                        this.loadData();
                    } else {
                        this.$notify({
                            title: '提示',
                            message: res.msg
                        });
                    }
                }).catch(e=>this.parseError(e));
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消'
                });
            });
        },
        clickEdit(row) {
            this.$router.push({
                name: 'promotionEdit',
                query: {
                    promotionId: row.promotionId
                }
            });
        },
        // clickUpdatePromotionStock(row) {
        //     this.stockInfo.oldMaxNum = row.maxNum;
        //     this.stockInfo.maxNum = row.maxNum;
        //     this.stockInfo.promotionId = row.promotionId;
        //     this.stockInfo.promotionName = row.promotionName;
        //     this.stockInfo.dialogFormVisible = true;
        // },
        updatePromotionStock() {
            let params = this.stockInfo;
            this.$api
            .updatePromotionStock(params)
            .then(res=>this.parseRes(res))
            .catch(e=>this.parseError(e));
        },
        addEdit() {
            if(this.$developerType === 3) {
                this.$router.push({
                    name: 'promotionEdit'
                });
            }else if(this.$developerType === 2) {
                this.operateDialogVisible = true;
            }
        },
        // 复制整行数据
        copyOneList(row) {
            this.$confirm('确定复制现有活动信息生成新的优惠券活动？', '复制活动', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$api.copyPromotion({promotionCode: row.promotionCode}).then(res => {
                    if (+res.code === 0) {
                        this.$message({
                            type: 'success',
                            message: '操作成功'
                        });
                        this.loadData();
                    } else {
                        this.$notify({
                            title: '提示',
                            message: res.msg
                        });
                    }
                }).catch(e => {
                    console.log('复制: ' + e);
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消复制'
                });
            });
        },
        // 查看该条优惠的数据展示
        viewData(row) {
            let promotionId = row.promotionId;
            this.$router.push({
                path: '/promotion/promotion-data',
                query: {promotionId}
            });
        },
        // 单条优惠券的时间查询
        singlePromotionTimeSearch() {
            let statisticDataParams = {
                promotionId: this.promotionId,
                startTime: Date.parse(this.couponDataTime[0]) || '',
                endTime: Date.parse(this.couponDataTime[1]) || '',
                couponUseRangType: this.searchObj.couponUseRangType
            };

            this.agg(statisticDataParams);
        },
        // 优惠券统计数据接口
        agg(statisticDataParams) {
            this.$api.statisticData(statisticDataParams).then(res => {
                if (+res.code !== 0) {
                    this.$notify({
                        title: '提示',
                        message: res.msg
                    });
                }
                let showDetailPromotionLength = this.showDetailPromotionArr.length;
                for (let resKey in res.data) {
                    for (let i = 0; i < showDetailPromotionLength; i++) {
                        if (resKey === this.showDetailPromotionArr[i].detailType) {
                            this.showDetailPromotionArr[i].detailContent = res.data[resKey];
                        }
                    }
                }
                this.showDataList = false;
            }).catch(e => {
                console.log(e);
            });
        },
        backList() {
            this.showDataList = true;
        }
    }
};
</script>
<style lang="less" scoped>
.el-button--mini,
.el-button--small {
    width: 75px;
}
.container {
    .title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        border: solid 1px #EBEEF5;
        color: #303133;
        font-size: 20px;
        padding: 20px 15px;
        border-radius: 4px;
        margin: 0 0 20px 0;
        .title-text {
            display: flex;
            align-items: center;
            .title-logo {
                width: 20px;
                margin-right: 12px;
            }
        }
        .add-button {
            float: right;
        }
    }

    .pagation-wrapper {
        background: #ffffff;
        display: flex;
        align-items: center;
        float: right;
        margin: 20px;
        .pagation-text {
            margin-right: 10px;
            font-weight: 400;
            color: #606266;
        }
    }

    .el-breadcrumb {
        margin: 20px;
    }

    .category-pic {
        background-size: contain;
        height: 60px;
        width: 60px;
    }
    .standard-codeVo {
        margin-bottom: 10px;
    }

    .search-btn {
        margin-left: 20px;
        margin-right: 10px;
    }

    .detail-line-wrapper {
        margin-top: 20px;
        .detail-line-data {
            font-size: 14px;
            color: #606266;
            line-height: 40px;
            padding-left: 20px;
        }
    }

    .el-row {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
    }

    .el-date-editor--datetimerange.el-input, .el-date-editor--datetimerange.el-input__inner {
        width: 450px;
    }
}

</style>